import React, { useState } from "react";
import {
  Menu,
  ChevronDown,
  ChevronUp,
  Headphones,
  PhoneCall,
} from "react-feather";
import americanExpress from "./img/americanExpress.svg";
import masterCard from "./img/masterCard.svg";
import netBanking from "./img/netBanking.svg";
import rupay from "./img/rupay.svg";
import visa from "./img/visa.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faInstagram, faTwitter, faLinkedin } from "@fortawesome/free-brands-svg-icons";



const Footer = () => {
  return (
    <>
       

      <section className="bg-dark py-4">
        <div className="container mt-4">

        <div className="text-start text-white mb-4">
            <h5>A2Z Yatra</h5>
            <p className="p2">
              Explore the world with A2Z Yatra, your trusted travel companion
              for unforgettable journeys. From serene getaways to thrilling
              adventures, we craft personalized travel experiences tailored to
              your dreams. Let us handle the details while you focus on making
              memories. Your perfect trip starts here!
            </p>
          </div>
 
          <div className="text-white text-start mb-5">
            <div className=" mb-2">
                Follow Us On
            </div>

            <span className="me-2">
            <FontAwesomeIcon icon={faFacebook} size="2x" />
            </span>

            <span className="me-2">
            <FontAwesomeIcon icon={faInstagram} size="2x" />
            </span>

            <span className="me-2">
            <FontAwesomeIcon icon={faTwitter} size="2x" />
            </span>

            <span className="me-2">
            <FontAwesomeIcon icon={faLinkedin} size="2x" />
            </span>

             
          </div>



          <hr/>

          <div className="text-white d-flex justify-content-between align-items-center">
            <div className="">
            Copyright © 2024 A2Z Yatra. All Rights Reserved
            </div>
            <div className="">
                <span className="me-2"><img src={americanExpress} className="img-fluid f1"/></span>
                <span className="me-2"><img src={masterCard} className="img-fluid f1"/></span> 
                <span className="me-2"><img src={rupay} className="img-fluid f1"/></span>
                <span className="me-2"><img src={visa} className="img-fluid f1"/></span>
            </div>
          </div>
        </div>
      
      </section>
    </>
  );
};

export default Footer; 